
<template>
    <div class="chart-gauge" ref="mianWrap">
      <v-chart :forceFit="true" :height="height" :data="data" :scale="scale" :padding="padding">
      <v-coord type="polar" :startAngle="startAngle" :endAngle="endAngle" :radius="0.75"></v-coord>
      <v-axis
        dataKey="value"
        :zIndex="2"
        :line="null"
        :label="null"
        :subTickLine="null"
        :tickLine="null"
        :grid="null"
      ></v-axis>
      <v-axis dataKey="1" :show="false"></v-axis>
      <v-series
        gemo="point"
        position="value*1"
        shape="pointer"
        :style="{ stroke: '#fff', lineWidth: 0 }"
        :active="false"
      ></v-series>
      <v-guide
        type="arc"
        :zIndex="0"
        :top="false"
        :start="arcGuide1Start"
        :end="arcGuide1End"
        :vStyle="arcGuide1Style"
      ></v-guide>
      <v-guide
        type="arc"
        :zIndex="1"
        :start="arcGuide2Start"
        :end="arcGuide2End"
        :vStyle="arcGuide2Style"
      ></v-guide>
      <v-guide
        type="html"
        :position="htmlGuidePosition"
        :html="htmlGuideHtml"
      ></v-guide>
    </v-chart>
    </div>
</template>

<style lang="stylus" scoped>
.chart-gauge{
  position: relative;
}

</style>
<script>
import { registerShape } from 'viser-vue'

registerShape('point', 'pointer', {
  draw(cfg, container) {
    let point = cfg.points[0]
    point = this.parsePoint(point)
    const center = this.parsePoint({
      x: 0,
      y: 0
    })
    container.addShape('line', {
      attrs: {
        x1: center.x,
        y1: center.y,
        x2: point.x,
        y2: point.y + 15,
        stroke: cfg.color,
        lineWidth: 5,
        lineCap: 'round'
      }
    })
    return container.addShape('circle', {
      attrs: {
        x: center.x,
        y: center.y,
        r: 9.75,
        stroke: cfg.color,
        lineWidth: 4.5,
        fill: '#fff'
      }
    })
  }
})

const scale = [{
  dataKey: 'value',
  min: 0,
  max: 10,
  tickInterval: 1,
  nice: true
}
]

const data = [
  { value: 5.6 }
]

export default {
  props: {
    sourceData: Array,
    padding: {
      type: Array,
      default: () => ([0, 0, 0, 0])
    },
    height: {
      type: Number,
      default: 450
    },
    borderWidth: {
      type: Number,
      default: 2
    },
    percent: {
      type: Number,
      default: 0
    },
    fontSize: Number,
    lineHeight: Number,
    label: String,
    labelColor: String,
    smallStrokeColor: String,
    bigStrokeColor: String,
    shadowColor: String,
    shadowBlur: Number
  },
  data() {
    return {
      data,
      scale,
      startAngle: -216,
      endAngle: 144,
      arcGuide1Start: [0, 0.965],
      arcGuide1End: [10, 0.965],
      arcGuide1Style: {
        stroke: this.smallStrokeColor,
        lineWidth: 10
      },
      arcGuide2Start: [0, 0.965],
      arcGuide2End: [10, 0.965],
      arcGuide2Style: {
        stroke: this.bigStrokeColor,
        lineWidth: 10,
        shadowColor: this.shadowColor,
        shadowBlur: this.shadowBlur,
        shadowOffsetY: 2,
        lineCap: 'round'
      },
      htmlGuidePosition: ['50%', '55%'],
      htmlGuideHtml: ''
    }
  },
  watch: {
    percent: {
      handler: function (val) {
        this.percent = val
        this.arcGuide2End = [this.percent / 10, 0.965]
        this.htmlGuideHtml = `
        <div style="text-align: center;">
          <p style="font-size: ${this.fontSize}px;color: rgba(51,51,51,1);margin: 0;line-height:${this.lineHeight}px; height: ${this.lineHeight}px;">
            ${this.percent}
            <span style="font-size: 12px;">%</span>
          </p>
          <p style="font-size: 12px; color: ${this.labelColor};margin: 0;height: ${this.lineHeight}px;">
            ${this.label}
          </p>

        </div>
      `
      },
      immediate: true
    }
  },
  methods: {

  },
  mounted() {
  }
}
</script>
